import gql from 'graphql-tag';

export default gql`
  mutation clientRemoveAllSellingList($input: ClientRemoveAllSellingListInput) {
    clientRemoveAllSellingList(input: $input) {
      userErrors {
        field
        message
      }
      success
    }
  }
`;
